/* eslint-disable react-hooks/exhaustive-deps */
import { useFormik } from "formik";
import TextInput from "../../../components/inputs/textInput";
import Button from "../../../components/buttons/button";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";

const VolumetricWeightCalculator = () => {
  const { t } = useTranslation();
  const formik = useFormik({
    initialValues: {
      parcels: "",
      weight: "",
      totalWeight: "",
      length: "",
      width: "",
      height: "",
    },
    onSubmit: (values) => {
      const { length, width, height, parcels } = values;

      const l = parseFloat(length);
      const w = parseFloat(width);
      const h = parseFloat(height);
      const p = parseFloat(parcels);

      if (!isNaN(l) && !isNaN(w) && !isNaN(h)) {
        const volumeCm = l * w * h;
        const volumeM3 = volumeCm / 1_000_000;
        const volumetricWeight = (volumeCm / 5000) * (isNaN(p) ? 1 : p);

        formik.setFieldValue("totalVolume", volumeM3.toFixed(4));
        formik.setFieldValue("volumetricWeight", volumetricWeight.toFixed(2));
      } else {
        formik.setFieldValue("totalVolume", "");
        formik.setFieldValue("volumetricWeight", "");
      }
    },
  });
  useEffect(() => {
    const totalWeight =
      parseFloat(formik.values.weight) * parseFloat(formik.values.parcels);
    if (!isNaN(totalWeight)) {
      formik.setFieldValue("totalWeight", totalWeight);
    }
  }, [formik.values.parcels, formik.values.weight]);
  return (
    <article className="p-4 bg-white rounded-2xl shadow-mainShadow">
      <h3 className="text-xl font-bold text-center text-mainBlue">
        {t("volumetricWeightCalculatorKG")}
      </h3>
      <h3 className="my-5 text-xl font-bold text-center">{t("PackageInformation")}</h3>
      <form onSubmit={formik.handleSubmit}>
        <TextInput
          label={t("numberOfParcels")}
          formik={formik}
          name={"parcels"}
          placeholder={""}
          number
        />
        <TextInput
          label={t("packageWeight")}
          formik={formik}
          name={"weight"}
          placeholder={""}
          number
        />
        <TextInput
          label={t("totalActualWeight")}
          formik={formik}
          name={"totalWeight"}
          placeholder={""}
          disabled
        />
        <div className="inputs">
          <TextInput
            label={t("lengthCM-")}
            formik={formik}
            name={"length"}
            placeholder={""}
            number
          />
          <TextInput
            label={t("widthCM-")}
            formik={formik}
            name={"width"}
            placeholder={""}
            number
          />
          <TextInput
            label={t("heightCM-")}
            formik={formik}
            name={"height"}
            placeholder={""}
            number
          />
        </div>
        <Button text={t("volumetricWeightKG")} className={"w-full bg-mainRed my-4"} />
        <TextInput
          label={t("totalVolumeM")}
          formik={formik}
          name={"totalVolume"}
          placeholder={""}
          disabled
        />
      </form>
    </article>
  );
};

export default VolumetricWeightCalculator;
